const blogData = [
  {
    id: 1,
    title: 'CSS Basic Box Model',
    timeToRead: '2 mins',
    image:
      'https://res.cloudinary.com/drrqslttj/image/upload/v1643122789/portfoilo/CSS-box-model_jxbmwh.jpg',
    link: 'https://mayurarde.hashnode.dev/css-basic-box-model'
  },
  {
    id: 2,
    title: 'Array methods',
    timeToRead: '10 mins',
    image:
      'https://res.cloudinary.com/drrqslttj/image/upload/v1643122794/portfoilo/array-methods_gz6une.png',
    link: 'https://mayurarde.hashnode.dev/basic-array-methods-every-js-developer-should-know'
  },
  {
    id: 3,
    title: 'Resources For Web Developer',
    timeToRead: '5 mins',
    image:
      'https://res.cloudinary.com/drrqslttj/image/upload/v1643122797/portfoilo/web-developer-resources_xzey45.jpg',
    link: 'https://mayurarde.hashnode.dev/useful-resources-for-web-developer'
  },
];

export default blogData;
